import React, { Fragment } from "react";
import { Input, RadioGroup, FormControl, FormGroup, Checkbox, FormControlLabel, TextField, Select, InputLabel, Typography, Slider } from "@material-ui/core";
import AutocompleteContainer from "../../containers/AutocompleteContainer";

export const PlaceField = ({ input, label, meta: { touched, error }, validity, tenant, ...rest }) => {
    // const hasError = touched && error;
    const hasError = validity && Boolean(validity.error);
    const id = input.name;

    const classes = {
        input: `form-control form-control-lg${hasError ? ' form-control-danger' : ''}`
    }

    return (
        <div className={`form-group${hasError ? ' has-danger' : ''}`}>
            <AutocompleteContainer
                id={id}
                input={input}
                tenant={tenant}
                // autocompleteitem={AutocompleteItem}
                {...rest}
                className={classes.input} />
            {hasError && <div className="form-control-feedback">Invalid input</div>}
        </div>
    );
}
export const apartmentResult = ({ input, validity, ...custom }) => {
    const error = validity && Boolean(validity.error);
    return (
        <div>
            <Typography>something</Typography>
        </div>
    )
}

export const renderInput = ({
    input,
    validity,
    ...custom
}) => {
    const error = validity && Boolean(validity.error);
    return (
        <FormControl>
            <Input
                {...input}
                {...custom}
                error={error}
            />
        </FormControl>
    )
}

export const renderTextField = ({
    input,
    label,
    required,
    //meta: { touched, error },
    validity,
    ...custom
}) => {
    const error = validity && Boolean(validity.error);
    return (
        <TextField
            {...input}
            {...custom}
            label={label}
            error={error}
        />
    )
}

export const renderCheckbox = ({ input, label, ...custom }) => (
    <FormControlLabel
        label={label}
        control={
            <Checkbox
                {...input}
                {...custom}
                checked={input.value ? true : false}
                onChange={(event, value) => input.onChange(value)}
            />
        }
    />
)

export const renderSelect = ({
    input,
    label,
    multiple,
    // meta: { touched, error },
    children,
    validity,
    ...custom
}) => {
    // This fixes multi-select fields, so that they can't have non-array values.
    // This might desync the field from the redux state.
    // It shouldn't matter, as it only affects empty fields.
    const multipleFix = multiple ? { value: (Array.isArray(input.value) ? input.value : []) } : {};
    const error = validity && Boolean(validity.error);
    return (
        <FormControl>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple={multiple}
                {...input}
                {...multipleFix} // Overwrite invalid value fields
                onChange={(event, element) => input.onChange(event.target.value)}
                children={children}
                {...custom}
                // error={touched && ( error ? true : false )}
                error={error}
            />
            {/* {( touched && error ) && <Typography color="error">{String( error )}</Typography>} */}
        </FormControl>
    )
}

export const renderRadioGroup = ({ input, validity, ...custom }) => (
    <FormControl>
        <RadioGroup
            {...input}
            {...custom}
            onChange={(event, value) => input.onChange(value)}
        />
    </FormControl>
)

export const renderFormGroup = ({ input, validity, ...custom }) => (
    <FormGroup
        {...input}
        {...custom}
        onChange={input.onChange}
    />
)

export const renderSlider = ({ input, ...custom }) => (
    <Slider
        {...input}
        {...custom}
        onChange={(event, value) => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
    />
);

export const renderRangeSlider = ({ input, ...custom }) => (
    <Slider
        {...input}
        {...custom}
        value={input.value || custom.defaultValue || [custom.min, custom.max]}
        onChange={(event, value) => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
    />
);